import Step1CartItemDesktop from '../cart-item/step-1-cart-item-desktop';
import React from 'react';
import { useAppSelector } from '../../../data/store';
import UndoCartItems from '../undo-cart-items/undo-cart-items';
import GroupRadio from '../cart-item/group-radio';
import SavedForLater from '../../saved-for-later/saved-for-later';
import { splitCartDataItemPerGroups } from '../../../data/data-provider';
import FreeWithYourPurchase from '../../free-with-your-purchase/free-with-your-purchase';

interface IStep1ProductsListDesktop {
    showYouMayAlsoLike: boolean;
}

const Step1ProductsListDesktop = (props: IStep1ProductsListDesktop) => {

    const cartData = useAppSelector(store => store.root.cartData);
    const groups = splitCartDataItemPerGroups(cartData);

    return (
        <div className="hidden md:block w-full md:w-8/12 lg:w-3/4 mb-6 md:mb-0">

            <div className="md:mr-3 lg:mr-6">
                <UndoCartItems />
            </div>

            <div>
                {
                    groups.map((group, i) => {

                        const isLastGroup = i === groups.length - 1;
                        const isGroupSelected = group.cartGroupID === cartData.cartGroupID;

                        return (
                            <div
                                key={ group.cartGroupID }
                                className={`cart-products-grid grid border rounded md:mr-3 lg:mr-6 ${ isGroupSelected ? 'bg-white' : 'bg-gray-150' } ${ isLastGroup ? '' : 'mb-4' }`}>

                                {/* headers */}
                                <>
                                    <div className="mx-4 my-2 flex items-center col-start-1 col-end-4">
                                        <GroupRadio group={ group } name="cart-group-desktop" />
                                    </div>
                                    <div className="mx-6 my-2 text-center">Quantity</div>
                                    <div className="mx-6 my-2 text-right">Price</div>
                                </>

                                <div className="border-b col-span-full" style={{
                                    height: '1px'
                                }} />

                                {
                                    group.cartItems && group.cartItems.map((cartItem, i) => {

                                        const isLastItem = group.cartItems && (i === group.cartItems.length - 1);
                                        return (
                                            <Step1CartItemDesktop
                                                key={ cartItem.cartItemGUID }
                                                cartItem={ cartItem }
                                                isFirstItem={ i === 0 }
                                                isLastItem={ !!isLastItem }
                                            />
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                }
            </div>

            <FreeWithYourPurchase />

            {
                /*
                showYouMayAlsoLike &&
                <div className="md:mr-3 lg:mr-6">
                    <YouMayAlsoLike />
                </div>
                */
            }

            {
                cartData.wishListData && cartData.wishListData.length > 0 &&
                <div className="md:mr-3 lg:mr-6">
                    <SavedForLater />
                </div>
            }
        </div>
    )
};

export default Step1ProductsListDesktop;